<template>
  <ul class="menu-list">
    <li
      v-for="(facet, index) in facetValues"
      :key="facet.name"
      :class="`${(index - 1) % 2 == 0 ? 'has-background-grey-lighter' : ''}`"
    >
      <label class="is-block">
        <input type="checkbox"
          v-model="facet.isRefined"
          @change="toggleRefinement(facet)"
          :value="facet.name"
          class="is-hidden"
        >
        <a :class="{ 'is-active': facet.isRefined }">
          <span class="facet-name">{{ facet.name }}</span>
          <span class="tag is-pulled-right">{{ facet.count }}</span>
        </a>
      </label>
    </li>
  </ul>
</template>

<script>
import { Component } from 'vue-instantsearch';

export default {
  mixins: [Component],
  props: {
    attribute: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      default: 100,
    },
    sortBy: {
      default() {
        return ['sponsor:desc', 'isRefined:desc', 'count:desc', 'name:desc'];
      },
    },
  },
  computed: {
    facetValues() {
      return this.searchStore.getFacetValues(
        this.attribute,
        this.sortBy,
      );
    },
  },
  methods: {
    toggleRefinement(value) {
      return this.searchStore.toggleFacetRefinement(
        this.attribute,
        value.name,
      );
    },
  },
  created() {
    this.searchStore.stop();
    this.searchStore.maxValuesPerFacet = this.limit;
    this.searchStore.addFacet(
      this.attribute,
      'and',
    );
    this.searchStore.start();
    this.searchStore.refresh();
  },
  destroyed() {
    this.searchStore.stop();
    this.searchStore.removeFacet(this.attribute);
    this.searchStore.start();
  },
};
</script>
